import { createContext, useContext } from 'react'

/** @type {import('react').Context<null | Record<string, unknown>>} */
export const AppShellLayoutContext = createContext(null)

/** @returns {Record<string, unknown>} */
export function useAppShellLayoutContext() {
  const ctx = useContext(AppShellLayoutContext)
  if (!ctx) {
    throw new Error('useAppShellLayoutContext must be used within AppShell')
  }
  return ctx
}
